import name from './name'

const selectSliceData = state => state[name]

const selectCycles = state => selectSliceData(state).cycles

export {
  selectCycles
}
